import React from 'react';
import PropTypes from 'prop-types';
import TextFormatter from 'utils/TextFormatter';

const OrderStatus = (props) => {

    const {currentStatus} = props;

    if (!currentStatus) {
        return null;
    }

    return (
        <span>
            {TextFormatter.humanizeTitle(currentStatus)}
        </span>
    );

};

OrderStatus.propTypes = {
    currentStatus: PropTypes.string
};

export default OrderStatus;



// WEBPACK FOOTER //
// ./src/components/order-status/OrderStatus.js